
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"260","height":"100","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#E6E9F3","d":"M112.5 67a1.5 1.5 0 011.5 1.5V97h-7V68.5a1.5 1.5 0 011.5-1.5h4zm13 13a1.5 1.5 0 011.5 1.5V97h-7V81.5a1.5 1.5 0 011.5-1.5h4zm39-19a1.5 1.5 0 011.5 1.5V97h-7V62.5a1.5 1.5 0 011.5-1.5h4zm13-20a1.5 1.5 0 011.5 1.5V97h-7V42.5a1.5 1.5 0 011.5-1.5h4zm13 11a1.5 1.5 0 011.5 1.5V97h-7V53.5a1.5 1.5 0 011.5-1.5h4zm13 12a1.5 1.5 0 011.5 1.5V97h-7V65.5a1.5 1.5 0 011.5-1.5h4zm13 16a1.5 1.5 0 011.5 1.5V97h-7V81.5a1.5 1.5 0 011.5-1.5h4zm13-6a1.5 1.5 0 011.5 1.5V97h-7V75.5a1.5 1.5 0 011.5-1.5h4zm13 10a1.5 1.5 0 011.5 1.5V97h-7V85.5a1.5 1.5 0 011.5-1.5h4zm13 2a1.5 1.5 0 011.5 1.5V97h-7v-9.5a1.5 1.5 0 011.5-1.5h4zm-104-22a1.5 1.5 0 011.5 1.5V97h-7V65.5a1.5 1.5 0 011.5-1.5h4zm-13 4a1.5 1.5 0 011.5 1.5V97h-7V69.5a1.5 1.5 0 011.5-1.5h4zm-39-64a1.5 1.5 0 011.5 1.5V97h-7V5.5A1.5 1.5 0 0195.5 4h4zm-13 40a1.5 1.5 0 011.5 1.5V97h-7V45.5a1.5 1.5 0 011.5-1.5h4zm-13 20a1.5 1.5 0 011.5 1.5V97h-7V65.5a1.5 1.5 0 011.5-1.5h4zm-13 10a1.5 1.5 0 011.5 1.5V97h-7V75.5a1.5 1.5 0 011.5-1.5h4zm-13-6a1.5 1.5 0 011.5 1.5V97h-7V69.5a1.5 1.5 0 011.5-1.5h4zm-13 8a1.5 1.5 0 011.5 1.5V97h-7V77.5a1.5 1.5 0 011.5-1.5h4zm-13-8a1.5 1.5 0 011.5 1.5V97h-7V69.5a1.5 1.5 0 011.5-1.5h4zm-13-4a1.5 1.5 0 011.5 1.5V97H3V65.5A1.5 1.5 0 014.5 64h4z"}})])
          )
        }
      }
    